export const MOBILE_BREAKPOINT = "1079px";

export const NAV_TOP_HEIGHT = "58px";

export const CONTENT_TOP = "95px";

export const CONTENT_DOUBLE_COLUMN_BREAKPOINT_PX = "1024px";

export const CONTENT_DOUBLE_COLUMN_BREAKPOINT = 1024;
